import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const opacityDots = keyframes`
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
`;

const SavingLoader = styled.div`
  display: flex;
  padding: 6px 0;
`;

const EachDot = styled.span<{ dotcolor: string }>`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: ${props => props.dotcolor};
  animation-name: ${opacityDots};
  animation-duration: 2.5s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  margin: 0 0.8rem;
`;

interface IAnimatingDotsProps {
  successiveDelay?: number;
  color?: string;
}

const AnimatingDots = ({ successiveDelay = 0.3, color = 'var(--neut5)' }: IAnimatingDotsProps) => (
  <SavingLoader>
    {[0, 1, 2, 3, 4].map(eachItem => (
      <EachDot
        key={eachItem}
        className="animating-dots"
        data-view-type="animating-dots"
        style={{
          animationDelay: `${successiveDelay * eachItem}s`,
        }}
        dotcolor={color}
      />
    ))}
  </SavingLoader>
);

export default AnimatingDots;
